// ProtectedRouteWrapper.tsx
import React from "react"

import ProtectedRoute from "@navigation/ProtectedRoute"

interface ProtectedRouteWrapperProps {
  element: React.ReactElement
}

const ProtectedRouteWrapper: React.FC<ProtectedRouteWrapperProps> = ({
  element,
}) => {
  return <ProtectedRoute>{element}</ProtectedRoute>
}

export default ProtectedRouteWrapper
